import React from 'react';
import { SupervisedUserCircle } from '@mui/icons-material';
import { Divider, Box, styled } from '@mui/material';
import { match } from 'ts-pattern';
import Page from 'components/new/Page';
import VerticalTabs from 'components/new/VerticalTabs';
import { useVerticalTabs } from 'components/new/VerticalTabs/useVerticalTabs';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';
import Users from './Users';
import Roles from './Roles';
import { UserManagementNavigationContextProvider } from './UserManagementNavigationContext';

enum UserManagementTab {
  Users = 'users',
  Roles = 'roles',
}

const ContentContainer = styled(Box)({
  flex: 1,
});

const UserManagementContent: React.FC = () => {
  const [canReadRoles] = useHasPermissions([RolePermission.ReadRole]);
  const { selectedTab, setSelectedTab } = useVerticalTabs<UserManagementTab>(
    UserManagementTab.Users,
  );

  const tabs = [
    {
      label: 'Users',
      id: UserManagementTab.Users,
    },
    ...(canReadRoles
      ? [
          {
            label: 'Roles',
            id: UserManagementTab.Roles,
          },
        ]
      : []),
  ];

  return (
    <Page
      heading="User management"
      spacing="lg"
      headingIcon={SupervisedUserCircle}
    >
      <Divider />
      <VerticalTabs
        tabs={tabs}
        selectedTab={selectedTab as UserManagementTab}
        onTabChange={setSelectedTab}
        renderContent={(tab) => (
          <ContentContainer>
            {match(tab)
              .with(UserManagementTab.Users, () => <Users />)
              .with(UserManagementTab.Roles, () => <Roles />)
              .otherwise(() => (
                <></>
              ))}
          </ContentContainer>
        )}
      />
    </Page>
  );
};

const UserManagement: React.FC = () => {
  return (
    <UserManagementNavigationContextProvider>
      <UserManagementContent />
    </UserManagementNavigationContextProvider>
  );
};

export default UserManagement;
